export const getRevshareRateQueryFn = async props => {
  const {
    httpClient,
    request
  } = props;
  const {
    productId,
    ...rest
  } = request;
  const response = await httpClient.post('https://manage.wix.com/premium-pricing/get-revshare-rate', {
    ...rest,
    productIds: [productId]
  });
  return response.data;
};
//# sourceMappingURL=get-revshare-rate.query.js.map